import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 overflow-hidden mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { style: {"margin-bottom":"-38px","margin-left":"-20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 p-4 pb-0\"><h3 class=\"mb-0\">Response Time</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-99\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>Last 30 Days</option><option value=\"1\">Last 40 Days</option><option value=\"2\">Last 50 Days</option><option value=\"3\">Last 60 Days</option><option value=\"4\">Last 90 Days</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "220",
              options: _ctx.responseTime,
              series: _ctx.time
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}